/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Radio from '@react/react-spectrum/Radio';
import Checkbox from '@react/react-spectrum/Checkbox';
import './radioWithCheckBoxes.scss';

class RadioWithCheckBoxes extends Component {
    renderCheckBoxes(checkBoxList) {
        return checkBoxList.map((checkBoxData) => {
            const {
                disabled,
                localizedText,
                ariaLabel,
                value,
                updateValue,
            } = checkBoxData;
            return (
                <div className="radio-with-checkboxes-checkbox">
                    <Checkbox
                        disabled={disabled}
                        key={localizedText}
                        defaultChecked={value}
                        label={localizedText}
                        ariaLabel={ariaLabel}
                        onChange={updateValue}
                    />
                </div>
            );
        });
    }

    render() {
        const {
            disabled,
            defaultChecked,
            label,
            ariaLabel,
            onChange,
            checkBoxList,
        } = this.props;
        return (
            <div className="radio-with-checkboxes">
                <div className="radio-with-checkboxes-radio">
                    <Radio
                        disabled={disabled}
                        checked={defaultChecked}
                        label={label}
                        ariaLabel={ariaLabel}
                        onChange={onChange} />
                </div>
                {!!checkBoxList.length
                    && (
                        <div className="radio-with-checkboxes-checkboxes">
                            {this.renderCheckBoxes(checkBoxList)}
                        </div>
                    )
                }
            </div>
        );
    }
}

export default observer(RadioWithCheckBoxes);
